/** The four module series' colours, read from the module identity ramp
    (ADR-0092) so a series is the same colour as its module's tab underline
    and launcher tile, plus the neutral fallback for a module this build does
    not know. Shared by the chart and the metric strip so a module reads the
    same colour in both. The series DOT is a StatusDot in the module's tint
    (`seriesDot`); the chart's line and area keep these stroke and fill
    classes. */
const SERIES_STYLE = {
  solve: {
    stroke: "stroke-pb-module-solve",
    fill: "fill-pb-module-solve",
  },
  vsm: {
    stroke: "stroke-pb-module-vsm",
    fill: "fill-pb-module-vsm",
  },
  hoshin: {
    stroke: "stroke-pb-module-hoshin",
    fill: "fill-pb-module-hoshin",
  },
  lama: {
    stroke: "stroke-pb-module-lama",
    fill: "fill-pb-module-lama",
  },
} as const;

const NEUTRAL_SERIES_STYLE = {
  stroke: "stroke-pb-border-strong",
  fill: "fill-pb-border-strong",
} as const;

type SeriesId = keyof typeof SERIES_STYLE;

const isSeriesId = (id: string): id is SeriesId =>
  Object.hasOwn(SERIES_STYLE, id);

export function seriesStyle(id: string) {
  return isSeriesId(id) ? SERIES_STYLE[id] : NEUTRAL_SERIES_STYLE;
}

/** The series' colour as StatusDot / ChartLegend colour props: the module's
    tint, or the neutral tone for a module this build does not know. */
export function seriesDot(
  id: string,
): { tint: SeriesId } | { tone: "neutral" } {
  return isSeriesId(id) ? { tint: id } : { tone: "neutral" };
}
